
import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import { useNavigate } from 'react-router-dom';
import { productService } from '../../service/productservice';

// Beauty product images (replace with your actual image paths)
import JimpoOriSheaButterCream180g from "../../public/category-img/beauty/s-l1600_prev_ui.png";
import JimpoOriSheaButterCream280g from "../../public/category-img/beauty/JimpoOriSheaButterFamilyCream280g.jpg";
import JimpoOriBlackSoap250g from "../../public/category-img/beauty/JimpoOriNaturalExfoliateAfricanBlackSoap250g_prev_ui.png";
import JimpoOriBlackSoap500g from "../../public/category-img/beauty/JimpoOriNaturalExfoliateAfricanBlackSoap500g_prev_ui.png";
import JimpoOriLagentLotion110g from "../../public/category-img/beauty/JimpoOriLagentLotion110g_prev_ui.png";
import JimpoOriSheaButterEarlyAgeCream180g from "../../public/category-img/beauty/JimpoOriSheaButterFamilyCream180g_prev_ui.png";
import JimpoOriSheaButterEarlyAgeCream280g from "../../public/category-img/beauty/JimpoOriSheaButterEarlyAgeSkinCareCream280g_prev_ui (1).png";
import DuduOsunBlackSoap150g from "../../public/category-img/beauty/DSC_3546-ff.png";
import NiveaLotionCocoa400ml from "../../public/category-img/beauty/NiveaCocoa_130x.png";
import NiveaNaturalGlowLotion200ml from "../../public/category-img/beauty/NiveaNaturalGlowLotion200ml.jpg";

import DangGentleFoamingFaceWash120ml from "../../public/category-img/beauty/DANG-Ageless-Everyday-Gentle-Foaming-Face-Wash-scaled_prev_ui.png";
import DangFaceBodyMineralSunscreen100ml from "../../public/category-img/beauty/DANG-Ageless-Face-and-Body-Mineral-Sunscreen-scaled_prev_ui.png";
import DangInvisibleFinishSunscreen60ml from "../../public/category-img/beauty/DangAgelessInvisibleFinishSunscreen60m_prev_ui.png";
import DangRestorationBodyMoisturizer200ml from "../../public/category-img/beauty/dang-ageless-everyday-gentle-foaming-face-wash-107558_prev_ui.png";

export const beautyproducts = [
  { id: 'BTY001', name: 'Jimpo Ori Shea Butter Family Cream 180g', brand: 'Jimpo Ori', price: '$9.95', img: JimpoOriSheaButterCream180g, description: 'Jumpo-Ori Shea Butter Family Cream is a nourishing and moisturizing cream enriched with the goodness of shea butter. Ideal for the whole family, it deeply hydrates and softens the skin, helping to restore moisture and improve skin texture. Known for its healing properties, it helps to soothe dry, rough skin, providing relief from irritation and leaving the skin feeling smooth and supple.' },
  { id: 'BTY002', name: 'Jimpo Ori Shea Butter Family Cream 280g', brand: 'Jimpo Ori', price: '$11.95', img: JimpoOriSheaButterCream280g, description: 'Jumpo-Ori Shea Butter Family Cream is a nourishing and moisturizing cream enriched with the goodness of shea butter. Ideal for the whole family, it deeply hydrates and softens the skin, helping to restore moisture and improve skin texture. Known for its healing properties, it helps to soothe dry, rough skin, providing relief from irritation and leaving the skin feeling smooth and supple.' },
  { id: 'BTY003', name: 'Jimpo Ori Natural Exfoliate African Black Soap 250g', brand: 'Jimpo Ori', price: '$14.95', img: JimpoOriBlackSoap250g, description: 'Jumpo-Ori Natural Exfoliate African Black Soap is a premium skincare product crafted with traditional African ingredients to gently exfoliate and cleanse the skin. Made from a blend of organic shea butter, cocoa pods, and plantain skins, this soap is perfect for removing dead skin cells, promoting a smooth, even complexion, and improving skin texture.' },
  { id: 'BTY004', name: 'Jimpo Ori Natural Exfoliate African Black Soap 500g', brand: 'Jimpo Ori', price: '$27.95', img: JimpoOriBlackSoap500g, description: 'Jumpo-Ori Natural Exfoliate African Black Soap is a premium skincare product crafted with traditional African ingredients to gently exfoliate and cleanse the skin. Made from a blend of organic shea butter, cocoa pods, and plantain skins, this soap is perfect for removing dead skin cells, promoting a smooth, even complexion, and improving skin texture.' },
  { id: 'BTY005', name: 'Jimpo Ori Lagent Lotion 110g', brand: 'Jimpo Ori', price: '$9.95', img: JimpoOriLagentLotion110g, description: 'Jumpo-Ori Lagent Lotion is a rich, nourishing body lotion formulated with natural ingredients to deeply hydrate and soften the skin. Infused with the goodness of shea butter, coconut oil, and essential oils, this lotion helps to lock in moisture, leaving your skin feeling smooth, soft, and supple.' },
  { id: 'BTY006', name: 'Jimpo Ori Shea Butter Early Age Skin Care Cream 180g', brand: 'Jimpo Ori', price: '$9.95', img: JimpoOriSheaButterEarlyAgeCream180g, description: 'Jumpo-Ori Shea Butter Early Age Skin Care is a premium skincare product designed to nourish and protect young skin. Rich in natural shea butter, this moisturizer is packed with vitamins A, E, and F, which help to hydrate and maintain the skins elasticity.' },
  { id: 'BTY007', name: 'Jimpo Ori Shea Butter Early Age Skin Care Cream 280g', brand: 'Jimpo Ori', price: '$14.95', img: JimpoOriSheaButterEarlyAgeCream280g, description: 'Jumpo-Ori Shea Butter Early Age Skin Care is a premium skincare product designed to nourish and protect young skin. Rich in natural shea butter, this moisturizer is packed with vitamins A, E, and F, which help to hydrate and maintain the skins elasticity.' },
  { id: 'BTY008', name: 'Dudu Osun Black Soap 150g', brand: 'Dudu Osun', price: '$2.00', img: DuduOsunBlackSoap150g, description: 'Dudu Osun African Black Soap is a traditional skincare product made from natural, handpicked ingredients that cleanse and rejuvenate the skin. Known for its deep cleansing properties, this soap is enriched with shea butter, palm kernel oil, honey, and citrus juices, offering a gentle yet effective solution for removing dirt, oil, and impurities.' },
  { id: 'BTY009', name: 'Nivea Lotion Nourishing Cocoa 400ml', brand: 'Nivea', price: '$3.88', img: NiveaLotionCocoa400ml, description: 'Nivea Lotion Nourishing Cocoa is a rich, indulgent body lotion designed to deeply moisturize and nourish dry skin. Infused with the natural goodness of cocoa butter, it helps to restore skins moisture balance and improve its elasticity, leaving your skin feeling soft, smooth, and hydrated.' },
  { id: 'BTY010', name: 'Nivea Natural Glow Lotion 200ml', brand: 'Nivea', price: '$2.28', img: NiveaNaturalGlowLotion200ml, description: 'Nivea Natural Glow Lotion is a lightweight body lotion designed to provide deep hydration while enhancing your skins natural radiance. Enriched with a blend of vitamin C and natural extracts, it works to even out skin tone, promoting a healthy, glowing complexion.' },
  { id: 'BTY011', name: 'Nivea Natural Glow Lotion 625ml', brand: 'Nivea', price: '$4.28', img: NiveaNaturalGlowLotion200ml, description: 'Nivea Natural Glow Lotion is a lightweight body lotion designed to provide deep hydration while enhancing your skins natural radiance. Enriched with a blend of vitamin C and natural extracts, it works to even out skin tone, promoting a healthy, glowing complexion.' },
  { id: 'BTY012', name: 'Dang! Ageless Everyday Gentle Foaming Face 120ml', brand: 'Dang!', price: '$16.98', img: DangGentleFoamingFaceWash120ml, description: 'Dang! Ageless Everyday Gentle Foaming Face Wash is a mild yet effective cleanser designed to refresh and rejuvenate the skin. Formulated with natural ingredients, it gently removes dirt, oil, and makeup without stripping the skins natural moisture.' },
  { id: 'BTY013', name: 'Dang! Ageless Face and Body Mineral Sunscreen 100ml', brand: 'Dang!', price: '$24.98', img: DangFaceBodyMineralSunscreen100ml, description: 'Dang! Ageless Face and Body Mineral Sunscreen is a broad-spectrum sunscreen designed to protect your skin from harmful UVA and UVB rays. Formulated with mineral-based ingredients like zinc oxide, it provides a lightweight, non-greasy barrier that shields the skin while allowing it to breathe.' },
  { id: 'BTY014', name: 'Dang! Ageless Invisible Finish Sunscreen 60ml', brand: 'Dang!', price: '$27.95', img: DangInvisibleFinishSunscreen60ml, description: 'Dang! Ageless Invisible Finish Sunscreen is a lightweight, broad-spectrum sunscreen that provides superior protection against both UVA and UVB rays without leaving a white residue. Its unique, invisible formula blends seamlessly into the skin, offering a smooth, matte finish.' },
  { id: 'BTY015', name: 'Dang! Ageless Restoration Body Moisturizer 200ml', brand: 'Dang!', price: '$20.98', img: DangRestorationBodyMoisturizer200ml, description: 'Dang! Ageless Restoration Body Moisturizer is a luxurious, hydrating body lotion designed to rejuvenate and restore the skins natural softness. Infused with nourishing ingredients like shea butter and vitamins, it helps to replenish moisture, smooth dry patches, and improve skin elasticity.' },
  { id: 'BTY016', name: 'Dang! Ageless Everyday Gentle Foaming Face Wash 120ml', brand: 'Dang!', price: '$16.98', img: DangGentleFoamingFaceWash120ml, description: 'Dang! Ageless Everyday Gentle Foaming Face Wash is a mild, refreshing cleanser designed to purify and nourish the skin without stripping away its natural moisture. Its gentle foaming formula effectively removes dirt, oil, and impurities, leaving the skin feeling fresh, clean, and balanced.' }
];

const ProductCard = ({ product, updateCartCount, forceUpdateKey }) => {
  const [inCart, setInCart] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const foundItem = storedCartItems.find((item) => item.id === product.id);
    if (foundItem) {
      setInCart(true);
      setQuantity(foundItem.quantity);
    } else {
      setInCart(false);
      setQuantity(0);
    }
  }, [product.id, forceUpdateKey]);

  const handleAddToCart = () => {
    if (!inCart) {
      setInCart(true);
      setQuantity(1);
      saveToLocalStorage(product, 1);
      updateCartCount();
    }
  };

  const handleProductClick = () => {
    navigate(`/product/${product.name}`);
  };

  const saveToLocalStorage = (product, quantity) => {
    const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const updatedCart = [...cartItems, { ...product, quantity }];
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-3 w-full flex flex-col justify-between">
      <div onClick={handleProductClick} className="relative cursor-pointer flex justify-center items-center">
        <img
          src={product.img}
          alt={product.name}
          className={`h-60 w-full object-cover rounded-lg ${product.quantity === 0 ? 'opacity-50' : ''}`}
        />
        {product.quantity === 0 && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
            <span className="text-white text-lg font-semibold">Out of Stock</span>
          </div>
        )}
      </div>
      <div className="mt-4">
        <h3 className="text-lg font-semibold">{product.name}</h3>
        <p className="text-[#007D44]">{product.brand}</p>
        <p className="text-[#007D44] font-bold mt-2">${product.price}</p>
      </div>
      {inCart ? (
        <div className="mt-4 flex items-center justify-between border bg-slate-100 shadow-md rounded-full">
          <button
            onClick={() => {
              if (quantity > 1) {
                setQuantity((prevQuantity) => prevQuantity - 1);
                updateCartCount();
              }
            }}
            className="bg-[#38c13a] text-white py-2 px-4 rounded-lg hover:bg-[#2e9830]"
          >
            -
          </button>
          <span className="text-lg font-semibold">{quantity}</span>
          <button
            onClick={() => {
              setQuantity((prevQuantity) => prevQuantity + 1);
              updateCartCount();
            }}
            className="bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44]"
          >
            +
          </button>
        </div>
      ) : (
        <button
          onClick={handleAddToCart}
          className={`mt-4 bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44] ${
            product.quantity === 0 ? 'cursor-not-allowed opacity-50' : ''
          }`}
          disabled={product.quantity === 0}
        >
          Add to cart
        </button>
      )}
    </div>
  );
};


const BeautyProducts = () => {
  const [cartCount, setCartCount] = useState(0);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);


  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [cloudinaryUrls, setCloudinaryUrls] = useState({});
  const [products, setProducts] = useState([]);

  const [hasIncompatibleItems, setHasIncompatibleItems] = useState(false); // New state
      

 // Auto-upload products when component mounts
 useEffect(() => {
  const uploadProducts = async () => {
    try {
      setIsUploading(true);

      // Prepare products for upload
      const productsToUpload = beautyproducts.map(product => ({
        ...product,
        id: product.id,
        name: product.name,
        brand: product.brand,
        description: product.description,
        category: 'beautyproducts',
        quantity: 0,
        price: parseFloat(product.price.replace('$', ''))
      }));

      try {
        const result = await productService.bulkCreateProducts(productsToUpload);
        
        setUploadStatus({
          success: true,
          message: `${result.created} beauty products uploaded successfully`
        });
      } catch (error) {
        setUploadStatus({
          success: false,
          message: error.response?.data?.message || 'Product upload failed'
        });
      }
    } catch (error) {
      console.error('Error uploading products:', error);
      setUploadStatus({
        success: false,
        message: 'Failed to upload products'
      });
    } finally {
      setIsUploading(false);
    }
  };


  // Fetch products by category
  const fetchProducts = async () => {
    try {
      const result = await productService.getProductsByCategory('beautyproducts');
      
      // If no products exist, trigger upload
      if (result.count === 0) {
        await uploadProducts();
      } else {
        setProducts(result.products);
        console.log(result.products)
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  fetchProducts();
}, []);

 

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items on initial load
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);
  }, []);

  const updateCartCount = () => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items whenever cart updates
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);
  };

  const forceUpdateProducts = () => {
    setForceUpdateKey(prevKey => prevKey + 1); // This will force a re-render in ProductCard
  };

  return (
    <>
      <Navbar cartCount={cartCount} updateCartCount={updateCartCount} forceUpdateProducts={forceUpdateProducts} /> {/* Pass cart count to Navbar */}

      {/* Upload Status Notification */}
      {isUploading && (
        <div className="fixed top-0 left-0 w-full bg-yellow-500 text-white text-center py-2 z-50">
          Uploading sponge products...
        </div>
      )}
      
      {uploadStatus && (
        <div 
          className={`
            fixed 
            top-0 
            left-0 
            w-full 
            text-center 
            py-2 
            z-50 
            ${uploadStatus.success ? 'bg-green-500' : 'bg-red-500'} 
            text-white
          `}
        >
          {uploadStatus.message}
        </div>
      )}

      <div className="min-h-screen p-8 max-sm:p-1 lg:mt-[70px] mt-[130px]">
      {hasIncompatibleItems && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">
            Your cart contains items from a different box type. Please complete your current order 
            or clear the cart before selecting individual sponge products.
          </span>
          <button
            onClick={() => setHasIncompatibleItems(false)}
            className="absolute top-0 right-0 px-2 py-1"
          >
            ×
          </button>
        </div>
      )}
        <div className="flex justify-between items-center max-sm:flex-col max-sm:items-start mb-6">

          <h3 className="text-2xl font-semibold">Beauty Products</h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              updateCartCount={updateCartCount}
              forceUpdateKey={forceUpdateKey} // Pass updateCartCount to ProductCard
            />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BeautyProducts;
